
<multi-input class="component search-component" :class="{compress: compress}">
  <prefix>
    <label :for="$attrs.id" class="search-label">
      <icon class="searchable"></icon>
      <span class="sr-only">Search Input</span>
    </label>
  </prefix>
  <column>
    <input type="search" v-model.sync="localValue" v-bind="$attrs" v-on="inputListeners" v-focus="focus" :autocomplete="autocomplete">
  </column>
  <suffix>
    <button @click="reset" @keydown.enter="reset" type="button" class="btn-icon input-color search-reset">
      <span class="sr-only">clear</span>
      <icon glyph="arrow-chevron" direction="up"></icon>
    </button>
  </suffix>
</multi-input>
